const accessPayment = {
    PAYMENT: { name: 'Payment', path: '/payment' },
    PAYMENT_RESULT: { name: 'Payment Result', path: '/payment/result' },
}

export default accessPayment;
